export function add_hand(e:any){
    e.preventDefault()
    let F = document.getElementById("add-form") as HTMLFormElement;
    F.style.display = "block";

    let inputContainer = document.createElement("div"); // Create a container for input and delete button
    inputContainer.classList.add("input-group"); // Add Bootstrap class for input group style

    let deleteButton = document.createElement("button"); // Create the delete button
    deleteButton.setAttribute("type", "button");
    deleteButton.classList.add("btn", "btn-danger"); // Add Bootstrap classes for danger button style
    deleteButton.innerText = "Delete";

    deleteButton.addEventListener("click", () => {
      if (document.querySelectorAll("#input-add-q").length > 1)
        inputContainer.remove(); // Remove the input container when delete button is clicked
    });

    inputContainer.innerHTML = `<input placeholder="Enter q key" id="input-add-q" class="form-control" required />`;
    inputContainer.appendChild(deleteButton);
    F.appendChild(inputContainer);
}

export function createHand(e: any) {
    e.preventDefault();
    let F = document.getElementById("create-form") as HTMLFormElement;
    F.style.display = "block";

    let inputContainer = document.createElement("div");
    inputContainer.classList.add("input-group");

    let deleteButton = document.createElement("button");
    deleteButton.setAttribute("type", "button");
    deleteButton.classList.add("btn", "btn-danger");
    deleteButton.innerText = "Delete";

    deleteButton.addEventListener("click", () => {
      if (document.querySelectorAll("#input-create-q").length > 1) {
        inputContainer.remove();
      }
    });

    inputContainer.innerHTML = `<input placeholder="Enter q key" id="input-create-q" class="form-control" required />`;
    inputContainer.appendChild(deleteButton);
    F.appendChild(inputContainer);
  }